import { Action } from 'react-fetching-library';

export const getLanguageList: Action = {
  method: 'GET',
  endpoint: 'items/langues_translation',
};
